import { Col, Grid, Row } from 'react-bootstrap'

import { INFO_MESSAGE_TYPE } from '../../constants/UserMessages'
import PropTypes from 'prop-types'
import React from 'react'
import SaxsDataCollectionsContainer from './SaxsDataCollectionsContainer'
import SaxsExperimentListPanel from '../../components/saxs/Experiment/SaxsExperimentListPanel'
import SaxsRequester from './helpers/SaxsRequester'
import SaxsSideBar from '../../components/saxs/SaxsSideBar'
import UserMessage from '../../components/saxs/UserMessage'
import { connect } from 'react-redux'
import { getSaxsExperimentsBySessionId } from '../../api/ispyb'
import { parseExperiments } from '../../helpers/Saxs/SaxsExperimentsMapper'
import { setBreadCrumbs } from '../../actions/breadcrumbs'

class SaxsExperimentsContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedExperimentId: null,
      selectedExperimentType: null,
    }

    this.setSelectedExperiment = this.setSelectedExperiment.bind(this)
  }

  render() {
    if (this.props.user.username === null || this.props.user.token === null) {
      return null
    }

    return (
      <SaxsSideBar
        sideBarComponent={
          <SideBarComponent
            proposal={this.props.proposal}
            selectedExperimentId={this.state.selectedExperimentId}
            sessionId={this.props.sessionId}
            setSelectedExperiment={this.setSelectedExperiment}
            user={this.props.user}
          />
        }
      >
        {!this.state.selectedExperimentId ? (
          <Grid fluid>
            <Row>
              <Col xs={12}>
                <UserMessage type={INFO_MESSAGE_TYPE} message="Please select an experiment from the list" />
              </Col>
            </Row>
          </Grid>
        ) : (
          <SaxsDataCollectionsContainer
            experimentId={this.state.selectedExperimentId}
            experimentType={this.state.selectedExperimentType}
            proposal={this.props.proposal}
            sessionId={this.props.sessionId}
          />
        )}
      </SaxsSideBar>
    )
  }

  setSelectedExperiment(experiment) {
    this.setState({ selectedExperimentId: experiment.id, selectedExperimentType: experiment.type })
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SaxsExperimentsContainer)

SaxsExperimentsContainer.propTypes = {
  /** proposal number */
  proposal: PropTypes.string,
  /** session identifier */
  sessionId: PropTypes.string,
}

class SideBarComponent extends React.Component {
  render() {
    return (
      <SaxsRequester
        url={getSaxsExperimentsBySessionId(this.props.user, this.props.proposal, this.props.sessionId)}
        parser={parseExperiments}
      >
        {experiments => (
          <SaxsExperimentListPanel
            experiments={experiments}
            selectedExperimentId={this.props.selectedExperimentId}
            onExperimentClicked={this.props.setSelectedExperiment}
          />
        )}
      </SaxsRequester>
    )
  }
}

SideBarComponent.propTypes = {
  /** Proposal number */
  proposal: PropTypes.string,
  /** Session identifier */
  sessionId: PropTypes.string,
  /** Callback function used to set the selected experiment */
  setSelectedExperiment: PropTypes.func,
  /** User */
  user: PropTypes.object.isRequired,
}
